import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import './CampDescription.css';

interface CampDescriptionProps {
  description: string | null;
  className?: string;
}

const CampDescription: React.FC<CampDescriptionProps> = ({ description, className = '' }) => {
  const defaultDescription = 'Join us for an exciting adventure! This camp offers a fun and engaging experience for kids to learn new skills and make friends.';

  return (
    <div className={`camp-description ${className}`}>
      <ReactMarkdown rehypePlugins={[rehypeSanitize]}>
        {description || defaultDescription}
      </ReactMarkdown>
    </div>
  );
};

export default CampDescription;
